import { inject, Injectable } from '@angular/core';
import { SupabaseService } from '../supabase.service';
import { BehaviorSubject } from 'rxjs';
import { User } from '@supabase/supabase-js';

@Injectable({providedIn: 'root'})
export class AuthService {
  private sb = inject(SupabaseService).client;

  private userSubject = new BehaviorSubject<User | null | undefined>(undefined);
  user$ = this.userSubject.asObservable();

  get user(): User | null {
    return this.userSubject.value || null;
  }

  get userId() {
    return this.user?.id || null;
  }

  constructor() {
    this.sb.auth.onAuthStateChange((event, session) => {
      // console.log('AuthSTateChange', event, session);
      this.userSubject.next(session?.user || null)
    })
  }

  signIn(email: string, password: string) {
    return this.sb.auth.signInWithPassword({email, password, options: {}});
  }

  signOut() {
    return this.sb.auth.signOut()
  }
}
